import { createContext, useContext } from 'react'
import { Analytics } from '@/types/analytics/Analytics'

export const AnalyticsContext = createContext<Analytics | null>(null)

export const useAnalytics = () => useContext(AnalyticsContext)
